import deepmerge from "deepmerge";
import { cloneDeep, set } from "lodash";
import React, { useCallback, useEffect, useMemo } from "react";

import { getValue, setStyles } from "@intelligems/ig-plugin/core";
import {
  DiscountMessageBoxWidget,
  DottedJoin,
  MessageBoxWidgetDeviceConfig,
  MessageBoxWidgetVariables,
  OfferDto,
} from "@intelligems/ig-types";
import { IgMessageBoxBase } from "@intelligems/ig-widgets";

interface MessageBoxWidgetStylePreviewProps {
  configType: "mobile" | "desktop";
  messageBoxWidget: DiscountMessageBoxWidget;
  threshold?: number;
  discountState?: OfferDto;
  userInterfaceVariables?: MessageBoxWidgetVariables;
}

export const IgDiscountMessageBox = ({
  configType,
  messageBoxWidget,
  userInterfaceVariables,
}: MessageBoxWidgetStylePreviewProps) => {
  const isMobile = "mobile" === configType;
  const prefix = `ig-pb-${messageBoxWidget.id}`;

  const MessageBoxWidget = useMemo(() => {
    const resp = cloneDeep(messageBoxWidget);
    if (!resp.config.desktop?.variables?.textReplacements) {
      set(resp, "config.desktop.variables.textReplacements", {});
    }
    if (
      userInterfaceVariables &&
      Object.keys(userInterfaceVariables).length > 0
    ) {
      resp.config.desktop!.variables!.textReplacements = deepmerge(
        resp.config.desktop!.variables!.textReplacements,
        userInterfaceVariables.textReplacements
      );
    }

    return resp;
  }, [
    messageBoxWidget,
    messageBoxWidget?.config?.desktop?.variables?.textReplacements,
    userInterfaceVariables?.textReplacements,
  ]);

  useEffect(() => {
    setStyles(
      prefix,
      MessageBoxWidget?.config?.desktop?.styles,
      MessageBoxWidget?.config?.mobile?.styles
    );
  }, [
    MessageBoxWidget?.config?.desktop?.styles,
    MessageBoxWidget?.config?.mobile?.styles,
    prefix,
  ]);

  const getWidgetConfig = useCallback(
    (path: DottedJoin<MessageBoxWidgetDeviceConfig>) => {
      let value;
      if (isMobile) {
        value = getValue(MessageBoxWidget.config.mobile, path as string);
      }

      if (!value) {
        value = getValue(MessageBoxWidget.config.desktop, path as string);
      }
      return value;
    },
    [MessageBoxWidget?.config, isMobile]
  );

  return (
    <IgMessageBoxBase
      isFe={true}
      idForHiding={"campaignId"}
      prefix={prefix}
      config={MessageBoxWidget.config}
      getWidgetConfig={getWidgetConfig}
      isMobile={isMobile}
    />
  );
};
